import { render } from "./Loading.vue?vue&type=template&id=25086ded&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=25086ded&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25086ded"]])

export default __exports__